import * as React from "react";
import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        data-slot="input"
        type={type}
        className={cn(
          "flex h-10 w-full rounded-lg border border-input",
          "bg-card backdrop-blur shadow-inset",
          "px-4 py-3 text-sm text-foreground placeholder:text-muted-foreground",
          "focus:border-primary/50 focus-visible:ring-2 focus-visible:ring-primary/30 focus-visible:outline-none",
          "transition-all duration-200",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "aria-invalid:border-destructive aria-invalid:ring-destructive/20",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
